export type EligibleVehiclesFilterCriteria = {
  pricingModels?: string[];
  fleetIds?: string[];
};

export const ELIGIBLE_VEHICLES_FILTER_EMPTY_STATE: EligibleVehiclesFilterCriteria =
  {
    pricingModels: [],
    fleetIds: [],
  };

export type EligibleVehiclesFilterKey = keyof EligibleVehiclesFilterCriteria;

export interface FleetInfo {
  fleetId: string;
  name: string;
}
